import { HamburgerMenu } from "./components/hamburgermenu";
import { initModals } from './components/modal';
import { FadeInText } from './components/fadeintext';
import { FadeInMedia } from './components/fadeinmedia';
import { AccordionAnimator } from "./components/accordionanimator";
import { horizontalScrollForTables } from './components/tablescroll';
import { videoControls } from './components/videocontrols';
import { Exterior360 } from './components/exterior360';
import { initInterior360 } from './components/interior360';
import { relatedStoriesSlider } from './components/relatedstoriesslider';
import { initHeroResizer } from './components/heroresizer';
import { SubMenuScroller } from './components/submenuscroller';
import { initTabMenu } from './components/tabmenu';
import { initAccessoryToggle } from './components/accessorytoggle';
import { pairedSliders } from './components/pairedsliders';
import { accessoriesSlider } from './components/accessoriesslider';
import { accessoriesPairsSliders } from './components/accessoriespairsslider';
import { initDivaIframe } from './components/divaiframe';
import { accessoriePackagesSlider } from './components/accessoriepackagesslider';
import { accessoriesSimpleSlider } from './components/accessoriessimpleslider';
import { initRecall } from './components/recall';
import './pricecalculator/price-calculator';

document.addEventListener('DOMContentLoaded', () => {
    horizontalScrollForTables();
    videoControls();
    relatedStoriesSlider();
    pairedSliders();
    accessoriesSlider();
    accessoriesPairsSliders();
    accessoriePackagesSlider();
    accessoriesSimpleSlider()

    initModals();
    initHeroResizer();
    initTabMenu();
    initAccessoryToggle();
    initDivaIframe();
    initRecall();

    //const flickerty = new Flickerty();
    //flickerty.init();

    document.querySelectorAll<HTMLElement>('[data-submenu]').forEach((container) => {
        SubMenuScroller(container);
    });

    document.querySelectorAll<HTMLElement>('[data-header-submenu]').forEach((container) => {
        SubMenuScroller(container);
    });

    document.querySelectorAll<HTMLElement>('[data-cubemap]').forEach(el => {
        initInterior360(el);
    });

    Exterior360.initFromDataAttributes();
    new HamburgerMenu('hamburger', 'menu');
    new FadeInText();
    new FadeInMedia();
    new AccordionAnimator({
        selector: '.accordion',
        groupSelector: '.accordion-group',
        duration: 200,
        easing: 'ease-in-out'
    });

});
